import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import ActionButton from '../../components/ActionButton.jsx'; 

const PaymentFailedPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const analysisId = searchParams.get('analysisId');
  
  return (
    <div className="flex justify-center min-h-full p-4 pt-8 pb-16 bg-gray-50">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl p-8 md:p-12">
        <div className="flex flex-col items-center text-center">
          <XCircle className="w-20 h-20 text-red-500 mb-6" />
          <h2 className="text-3xl font-bold text-gray-800">Platba se nezdařila</h2>
          <p className="text-gray-600 mt-4 text-lg">
            Při zpracování vaší platby došlo k chybě. Zkuste to prosím znovu.
          </p>
          
          {analysisId ? (
            <ActionButton 
              onClick={() => navigate(`/analysis/create?step=3&fileId=${analysisId}`)}
              className="mt-10 w-full"
            >
              Zpět k analýze
            </ActionButton>
          ) : (
            <ActionButton 
              onClick={() => navigate('/dashboard')}
              className="mt-10 w-full"
            >
              Zpět na Dashboard
            </ActionButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedPage;